import React from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton
} from "react-accessible-accordion";

const FAQPageAccordionForAdmins = () => {

  return (
    <Accordion preExpanded={[1]} key="becomeAHostPageFAQ" allowZeroExpanded >
      <AccordionItem uuid={1}>
        <AccordionItemHeading>
          <AccordionItemButton>
            How can AllCourse support my school?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            AllCourse makes teacher staffing much easier. You can find a large number of highly qualified,
            credentialed teachers to teach online courses for your students. They can teach entire courses, or
            just fill in for a while if a teacher at your school has to take an unexpected leave of absence.
          </p>
          <p>
            AllCourse allows you to offer a much larger course catalog. In addition to core curricula, you can
            expect to find a great many courses in foreign languages, computer science, special education, arts & music,
            Advanced Placement, test prep, etc. You might find courses with 8-person max class sizes. You might find
            girls-only STEM courses. You might find courses taught by teachers at famous schools or even professors
            from famous colleges.
          </p>
          <p>
            Schools with extra capacity or unusual capabilities can earn income to help fund school operations by sharing
            those capabilities on AllCourse with other schools that need them.
          </p>
          <p>
            AllCourse works better for everyone when more nearby schools use it. Other schools would love to have online
            access to your teachers, and you’d benefit from online access to theirs as well. And if you invite other
            schools and teachers to AllCourse, you can earn valuable credits that your school can apply to future
            AllCourse purchases.
          </p>
        </AccordionItemPanel>
      </AccordionItem>


      <AccordionItem uuid={2}>
        <AccordionItemHeading>
          <AccordionItemButton>
            What if my school is required to have an on-ground teacher for any course we offer?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            We’d recommend choosing a teacher-facilitator from your school to be in the room while students are taking courses on AllCourse. 
            If a number of students are taking different courses at the same time, they can wear headphones and do their work in front of a 
            dedicated screen. If students are all taking the same course, they can view their AllCourse teacher on one large screen in 
            the front of the classroom. Either way, the on-ground teacher can monitor behavior, answer questions, and help keep the students on track.
          </p>
          <p>
            Paying two teachers to teach one course may seem unnecessary, but there are a number of reasons why schools may choose to do this. 
            It’s possible they simply cannot find a local teacher who is qualified to teach the material, because the subject matter skill set 
            is rare, or perhaps because they had a teacher who departed suddenly. Maybe the school only wants an AllCourse teacher to supplement 
            their own efforts. Or perhaps the school wishes to offer a robust course catalog including every kind of AP Course, foreign language, 
            computer science, special education etc. For a little bit of extra budget, that school can now effectively offer parents and students 
            just about any subject matter imaginable.
          </p>
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem uuid={3}>
        <AccordionItemHeading>
          <AccordionItemButton>
            What qualifications will teachers possess?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            Teachers on AllCourse list their qualifications in their teacher profile. They are also strongly encouraged
            to post sample videos and references. While AllCourse works hard to vet every teacher before they are approved
            for our platform, we strongly recommend that you vet teachers on your own, watch their videos, and chat with
            them online before the course begins.
          </p>
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem uuid={4}>
        <AccordionItemHeading>
          <AccordionItemButton>
            What happens at the end of the course? Do students receive a grade?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            Yes, AllCourse teachers will assign grades just as they would if they were teaching in your school building.
          </p>
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem uuid={5}>
        <AccordionItemHeading>
          <AccordionItemButton>
            How can I negotiate a course time to better fit my school’s student schedules?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            You can contact teachers directly through our chat feature to negotiate times or ask a teacher to add a new section.
          </p>
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem uuid={6}>
        <AccordionItemHeading>
          <AccordionItemButton>
            What if I can’t find enough teachers from my state on AllCourse?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            AllCourse is a new marketplace. We opened the marketplace in just a few states to begin with. If you can’t find many
            teachers who are credentialed in your region, it’s probably because we haven’t yet officially launched there and begun
            recruiting teachers. However, teachers from all over are joining AllCourse every day, even without us actively recruiting them.
            So please bear with us during these early days, and keep checking back as we grow. You can also email
            us at <a href="mailto:support@allcourse.com">support@allcourse.com</a> to tell us of your interest, and we will prioritize your
            location for teacher recruitment.
          </p>
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem uuid={7}>
        <AccordionItemHeading>
          <AccordionItemButton>
            How much does it cost? What payment methods do you accept?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            AllCourse is free to find courses, browse teachers, and post jobs.
          </p>
          <p>
            Once you find a course you want to buy seat(s) in, you purchase seats on the course listing page.
            How much it costs will depend on how many seats you want to buy, and the teacher’s per-seat rate for that course.
          </p>
          <p>
            We accept credit card payments through our website. Or, you can use other payment methods by
            emailing <a href="mailto:support@allcourse.com">support@allcourse.com</a>.
          </p>
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem uuid={8}>
        <AccordionItemHeading>
          <AccordionItemButton>
            What’s to stop admins and teachers from meeting on AllCourse and then transacting offline,
            in order to avoid paying AllCourse’s service fee?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            It is a violation of our Terms of Service. AllCourse’s service fees are modest compared to other marketplaces,
            and they are necessary in order to keep the platform running and to add new features and improvements.
            Schools and teachers who meet on AllCourse and then transact offline in order to avoid paying service fees will,
            at a minimum, be banned from using AllCourse in the future.
          </p>
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem uuid={9}>
        <AccordionItemHeading>
          <AccordionItemButton>
            What is your refund policy?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            School admins can cancel seats and receive a refund, depending on when they cancel. For most courses, you can
            cancel and request a refund anytime during the first week of classes. This allows everyone involved to make sure
            that the fit is right between the student and the class. However, some courses are very short, such as custom
            courses that teachers offer to a particular school to solve a short-term staffing crisis. If a course is less
            than 3 weeks long, you can cancel and request a refund anytime prior to the first class session.
          </p>
          <p>
            In the event that a teacher wishes to cancel a course listing, they may do so under the following conditions:
          </p>
          <ul>
            <li>the minimum number of seats have not yet been met; and</li>
            <li>the course start date has not passed</li>
          </ul>
          <p>
            This allows for teachers to cancel courses that do not meet their profitability threshold, but protects school
            administrators so that they can rely on seats they pay for being fulfilled. If a teacher cancels a course,
            100% of the cost of the seats will be refunded to all purchasers.
          </p>
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem uuid={10}>
        <AccordionItemHeading>
          <AccordionItemButton>
            How do referrals work and what are the eligibility requirements?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            For a limited time, school administrators can earn credits by inviting teachers to AllCourse. 
            To avoid any possible conflict of interest, referral bonuses are not paid directly to the referring administrator. 
            Rather, they count as credits that can be deducted against any future AllCourse purchases made by the admin’s school.
          </p>
          <p>
            For every teacher you refer, we’ll give you the first $200 in service fees they generate for AllCourse. 
            For every admin you refer, we’ll give you the first $400 in service fees they generate for AllCourse
          </p>
          <p>
            Examples: You refer a teacher who teaches a course that generates $400 in service fees for AllCourse. You receive $200 in credits 
            for your school. Or, you refer a school administrator who ends up purchasing a number of seats in various courses for their students, 
            generating $500 in service fees for AllCourse. You receive $400 in credits for your school.
          </p>
          <p>
            For a referral to be valid, it must be the first time that person joined AllCourse. Referral bonuses are deducted 
            from AllCourse service fees, which means you will receive bonuses when teachers you refer have taught courses on 
            AllCourse and/or when admins you refer have purchased courses on AllCourse.
          </p>
          <p>
            These referral bonuses are meant to be a big THANK YOU to early adopters for helping spread the word.
          </p>
        </AccordionItemPanel>
      </AccordionItem>

    </Accordion>
  );
};

export default FAQPageAccordionForAdmins;
